import { BsStarHalf, BsStarFill } from 'react-icons/bs'
import React from 'react'
import {useHistory} from 'react-router-dom'
import { formatNumber } from '../../../utils/common'
interface propsCourseRatings{
  rating: number
  totalReviews: number
  courseId: number
}
const CourseRatings = (props: propsCourseRatings) => {
  const history = useHistory();
  const allRating = Math.ceil(props.rating);
  const fullRating = Math.floor(props.rating);
  const haveHalf = props.rating % fullRating !== 0;
  const stars = new Array(allRating).fill(null).map((_, i) => i + 1);
  return (
    <>
      <div className={"cd-rating flex flex-col items-center"}>
        <div className="flex mb-3">
          {stars.map((s, index) => {
            return index === allRating - 1 && haveHalf ? (
              <BsStarHalf
                key={`r-${index}-${new Date()}`}
                size="1.5rem"
                className={`fill-secondary ${
                  index !== allRating - 1 ? "me-1" : ""
                }`}
              />
            ) : (
              <BsStarFill
                key={`r-${index}-${new Date()}`}
                size="1.5rem"
                className={`fill-secondary ${
                  index !== allRating - 1 ? "me-1" : ""
                }`}
              />
            );
          })}
        </div>
        <button
          type="button"
          className="underline cursor-pointer bg-transparent border-0 p-0 text-inherit"
          onClick={() => {
            if (props.totalReviews > 0) {
              history.push(`/course/reviews/${props.courseId}`);
            }
          }}
        >
          {props.rating} ({formatNumber(props.totalReviews)} ulasan)
        </button>
      </div>
    </>
  );
}

export default CourseRatings;

export const CourseRatingsFlat = (props: propsCourseRatings) => {
  const isFull = props.rating === 5;

  return (
    <>
      <div className="flex justify-between items-center mb-3 w-full">
        <div className="flex items-center">
          { isFull ? <BsStarFill className="fill-secondary mr-2"  /> : <BsStarHalf className="fill-secondary mr-2"  /> }
          <span className="font-bold mr-2">{props.rating}</span>
          <span className="font-bold">({formatNumber(props.totalReviews)} Ulasan)</span>
        </div>
      </div>
    </>
  );
}
